<template>
    <pt-dialog-v2
        custom-class="heatmap-verify-dialog"
        :title="t('heatmap.verify_title')"
        :model-value="props.visible"
        :showCancelButton="false"
        :confirmText="t('onboTip.got_it')"
        @close="handleClose"
        @confirm="handleClose"
    >
        <div :class="$style.dialogContent">
            <p :class="$style.dialogConfirm">{{ t('heatmap.verify_content') }}</p>
            <div :class="$style.tipContent">
                <div v-for="(item, index) in tipData" :key="index" :class="$style.tipBase">
                    <p :class="$style.tipIndex">{{ index + 1 }}</p>
                    <p :class="$style.tipText">{{ item }}</p>
                </div>
            </div>
        </div>
    </pt-dialog-v2>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

// interface
interface Props {
    visible: boolean;
}
// props
const props = defineProps<Props>();
// emits
const emit = defineEmits(['close']);
// state
const { t } = useI18n();

const tipData = ref([t('heatmap.verify_tip1'), t('heatmap.verify_tip2'), t('heatmap.verify_tip3')]);

function handleClose() {
    emit('close');
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
.dialogContent {
    .dialogSubtitle {
        font-weight: 400;
        font-size: 13px;
        color: $pt-black-600;
        margin: 0 0 34px;
    }
    .dialogConfirm {
        font-weight: 400;
        font-size: 13px;
        color: $pt-black-900;
        margin-bottom: 16px;
    }
    .tipContent {
        background-color: $pt-info-hover;
        padding: 24px 24px 12px;
        border: 1px solid #c8eafc;
        border-radius: 4px;
        .tipBase {
            display: flex;
            margin-bottom: 12px;
            .tipIndex {
                width: 16px;
                height: 16px;
                background-color: $pt-info;
                border-radius: 50%;
                color: $pt-white;
                font-size: 12px;
                line-height: 14px;
                display: flex;
                justify-content: center;
                margin-right: 8px;
                margin-top: 2px;
                flex: 0 0 16px;
            }
            .tipText {
                font-family: 400;
                font-size: 13px;
                line-height: 20px;
                color: $pt-black-600;
            }
        }
    }
    .contact {
        font-weight: 400;
        font-size: 13px;
        line-height: 20px;
        color: $pt-black-300;
        a {
            text-decoration: underline;
            cursor: pointer;
            transition: 0.3s all;
            &:hover {
                text-decoration: underline;
                color: #091e42;
            }
        }
    }
}
:global {
    .heatmap-verify-dialog {
        .pt-dialog__title {
            font-weight: 500;
            font-size: 20px;
            color: $pt-black-900;
            text-align: center;
            display: block;
        }
    }
}
</style>
